import { BoxProps, TextProps } from '@jfs/ui-new'

const styles = (hide: boolean) => ({
  centerAlignment: {
    display: 'flex',
    paddingVertical: hide ? 0 : 10,
    alignItems: 'center',
    alignSelf: 'center',
    paddingHorizontal: 5,
    width: '100%',
  } as BoxProps,
  titleEmpty: {
    color: 'BLACK',
    fontSize: 12,
    fontWeight: '500',
    padding: 16,
    textAlign: 'center',
  } as TextProps,
})

export default styles
